import { getOnBoardingAPIData, getOnBoardingAPIStatus,getCurrentRole, setCurrentRole } from "src/slices/onBoardingSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RouteConstants, USER_ROLE } from "src/constants/constants";
import React from "react";
import EmptyDashboard from "src/pages/dashboard/EmptyDashboard";

export const OverviewPermisson = (props: any) => {
    const userOnboardAPIStatus = useSelector(getOnBoardingAPIStatus);
    const userOnboardStatus = useSelector(getOnBoardingAPIData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const current_role = useSelector(getCurrentRole);

    useEffect(() => {
      if (userOnboardStatus?.roles?.length && !current_role) {
        const roles = userOnboardStatus.roles.filter(role => role !== USER_ROLE.VIEWER  && role !== USER_ROLE.REVIEWER);
        if (roles.length) {
          dispatch(setCurrentRole(roles[0]));
        }
      }
    }, [userOnboardStatus])
   

    useEffect(() => {
      console.info(current_role);
        if (userOnboardAPIStatus === 'finished' && userOnboardStatus) {
            if (userOnboardStatus.user_onboard_status === 'on-boarded') {
              if (userOnboardStatus?.roles && userOnboardStatus.roles.length && (current_role === USER_ROLE.VIEWER || current_role === USER_ROLE.REVIEWER)) { 
               navigate(RouteConstants.DASHBOARD);
              }
            } else if (userOnboardStatus.user_onboard_status === 'eligible') {
              navigate(RouteConstants.ONBOARDING);
            } else if (userOnboardStatus.user_onboard_status === 'not-eligible') {
              navigate(RouteConstants.FORBIDDEN);
            } else {
              navigate(RouteConstants.PAGE_NOT_FOUND);
            }
          } else if (userOnboardAPIStatus === 'error') {
            navigate(RouteConstants.PAGE_NOT_FOUND);
          }
    }, [userOnboardStatus, userOnboardAPIStatus, current_role])

   if(userOnboardAPIStatus !== 'finished'){
        return <EmptyDashboard />
      }

      return <>{props.children}</>
      
}